"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateLoanTapeTypeMap = exports.ensureNoDuplicateDependencies = exports.removeDependencies = exports.removeDependency = exports.removeArtifactsByTypes = exports.removeDependenciesByOutputArtifactId = exports.removeDependenciesByInputArtifactId = exports.insertDependency = exports.getDependency = exports.filterUserInputNeededNodesBusApproval = exports.filterUserInputNeededNodesDataLakeWait = exports.filterUserInputNeededNodesCashBalanceContext = exports.filterUserInputNeededNodesForAssignment = exports.getOutputTapes = exports.getDependenciesByInputId = exports.getAllDependencyInputTapes = exports.getInputTapes = exports.getDependenciesByOutputId = exports.filterApprovalReports = exports.filterFundingRequests = exports.filterCashBalancesFeedContexts = exports.filterReconciledBusTapes = exports.filterManualBankAccountReports = exports.filterWaitForDataLakeTables = exports.filterCashResponseTapes = exports.filterInternalRepaymentTapes = exports.filterSyntheticAssignedRepaymentTapes = exports.filterAssignedRepaymentTapes = exports.filterGeneratedRepaymentTapes = exports.filterGeneratedCashBalanceFeeds = exports.filterValleySlsIngest = exports.filterDirectInsertBorrowingBaseReports = exports.filterBorrowingBaseReports = exports.filterReceivableResponseTapePreviews = exports.filterAssignedLoanTapes = exports.filterReceivableResponseTapes = exports.filterMasterLoanTapes = exports.filterReceivableInvoiceTapes = exports.filterReceivableDocumentationVerificationReportTapes = exports.filterGeneratedLoanTapes = exports.filterGeneratedCovenantLoanTapes = exports.filterRawSupplementTapes = exports.findOptionalArtifactBySlug = exports.findArtifactBySlugAndValidateLp = exports.findArtifactBySlug = exports.findArtifactById = exports.parseArtifactDocumentId = exports.hasLoanProductSlug = exports.hasCreditFacilitySlug = void 0;
const lodash = __importStar(require("lodash"));
const remeda_1 = require("remeda");
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const dbNodes = __importStar(require("./dbNodes"));
const { cloneDeep, isArray, every, isString } = lodash;
const hasCreditFacilitySlug = (artifacts) => {
    return (isArray(artifacts) &&
        every(artifacts, (artifact) => isString(artifact.creditFacilitySlug)));
};
exports.hasCreditFacilitySlug = hasCreditFacilitySlug;
const hasLoanProductSlug = (artifacts) => {
    return every(artifacts, (artifact) => isString(artifact.loanProductSlug));
};
exports.hasLoanProductSlug = hasLoanProductSlug;
const parseArtifactDocumentId = (dataTapes) => {
    const artifactDocumentIds = (0, remeda_1.pipe)(dataTapes, (0, remeda_1.map)(({ artifactDocumentId }) => artifactDocumentId), (0, remeda_1.uniq)());
    (0, common_1.finleyAssert)(artifactDocumentIds.length === 1, 'artifactDocumentId must be unique');
    return artifactDocumentIds[0];
};
exports.parseArtifactDocumentId = parseArtifactDocumentId;
const findArtifactById = ({ artifactId, dataTapes, }) => {
    const filterDataTapes = (0, remeda_1.filter)(dataTapes, ({ id }) => id === artifactId);
    (0, common_1.finleyAssert)(filterDataTapes.length === 1, `single [artifactId:${artifactId}] not found. [Found:${filterDataTapes.length}]`);
    return filterDataTapes[0];
};
exports.findArtifactById = findArtifactById;
const findArtifactBySlug = ({ artifactSlug, dataTapes, }) => {
    const filterDataTapes = (0, remeda_1.filter)(dataTapes, (tape) => tape.artifactSlug === artifactSlug);
    (0, common_1.finleyAssert)(filterDataTapes.length === 1, `Expected to find single artifact, but found [count:${filterDataTapes.length}] for [artifactSlug:${artifactSlug}]`);
    return filterDataTapes[0];
};
exports.findArtifactBySlug = findArtifactBySlug;
const findArtifactBySlugAndValidateLp = (inputs) => {
    const { artifactSlug, dataTapes, loanProductSlug } = inputs;
    const targetArtifact = (0, exports.findArtifactBySlug)({ dataTapes, artifactSlug });
    (0, common_1.finleyAssert)(targetArtifact.loanProductSlug === loanProductSlug, `Mismatched loan product artifact [artifactSlug:${artifactSlug}] [targetLpSlug:${loanProductSlug}] [foundLpSlug:${targetArtifact.loanProductSlug}]`);
    return targetArtifact;
};
exports.findArtifactBySlugAndValidateLp = findArtifactBySlugAndValidateLp;
const findOptionalArtifactBySlug = (params) => {
    const { artifactSlug, dataTapes } = params;
    const filterDataTapes = dataTapes.filter((tape) => tape.artifactSlug === artifactSlug);
    (0, common_1.finleyAssert)(filterDataTapes.length <= 1, `Expected to find 0 or 1 target artifact, found ${filterDataTapes.length} for [artifactSlug:${artifactSlug}]`);
    return filterDataTapes[0] ?? null;
};
exports.findOptionalArtifactBySlug = findOptionalArtifactBySlug;
const filterRawSupplementTapes = ({ dataTapes, }) => dataTapes.filter(dbNodes.rawSupplementalTape.isNode);
exports.filterRawSupplementTapes = filterRawSupplementTapes;
const filterGeneratedCovenantLoanTapes = ({ dataTapes, }) => dataTapes.filter(dbNodes.generatedCovenantLoanTape.isNode);
exports.filterGeneratedCovenantLoanTapes = filterGeneratedCovenantLoanTapes;
const filterGeneratedLoanTapes = ({ dataTapes, }) => dataTapes.filter(dbNodes.generatedLoanTape.isNode);
exports.filterGeneratedLoanTapes = filterGeneratedLoanTapes;
const filterReceivableDocumentationVerificationReportTapes = ({ dataTapes, }) => dataTapes.filter(dbNodes.receivableDocumentationVerificationReport.isNode);
exports.filterReceivableDocumentationVerificationReportTapes = filterReceivableDocumentationVerificationReportTapes;
const filterReceivableInvoiceTapes = ({ dataTapes, }) => dataTapes.filter(dbNodes.receivableInvoice.isNode);
exports.filterReceivableInvoiceTapes = filterReceivableInvoiceTapes;
const filterMasterLoanTapes = ({ dataTapes, }) => dataTapes.filter(dbNodes.masterLoanTape.isNode);
exports.filterMasterLoanTapes = filterMasterLoanTapes;
const filterReceivableResponseTapes = ({ dataTapes, }) => dataTapes.filter(dbNodes.receivableResponseTape.isNode);
exports.filterReceivableResponseTapes = filterReceivableResponseTapes;
const filterAssignedLoanTapes = ({ dataTapes, }) => dataTapes.filter(dbNodes.assignedLoanTape.isNode);
exports.filterAssignedLoanTapes = filterAssignedLoanTapes;
const filterReceivableResponseTapePreviews = ({ dataTapes, }) => dataTapes.filter(dbNodes.receivableResponseTapePreview.isNode);
exports.filterReceivableResponseTapePreviews = filterReceivableResponseTapePreviews;
const filterBorrowingBaseReports = ({ dataTapes, }) => dataTapes.filter(dbNodes.borrowingBaseReport.isNode);
exports.filterBorrowingBaseReports = filterBorrowingBaseReports;
const filterDirectInsertBorrowingBaseReports = ({ dataTapes, }) => dataTapes.filter(dbNodes.directInsertBorrowingBaseReport.isNode);
exports.filterDirectInsertBorrowingBaseReports = filterDirectInsertBorrowingBaseReports;
const filterValleySlsIngest = ({ dataTapes, }) => dataTapes.filter(dbNodes.valleyBankSlsIngest.isNode);
exports.filterValleySlsIngest = filterValleySlsIngest;
const filterGeneratedCashBalanceFeeds = ({ dataTapes, }) => dataTapes.filter(dbNodes.generatedCashBalanceFeed.isNode);
exports.filterGeneratedCashBalanceFeeds = filterGeneratedCashBalanceFeeds;
const filterGeneratedRepaymentTapes = ({ dataTapes, }) => dataTapes.filter(dbNodes.generatedRepaymentTape.isNode).filter((artifact) => {
    (0, common_1.finleyAssert)(dbNodes.generatedRepaymentTape.typeGuard(artifact), `[${artifact.id}] is not "GeneratedRepaymentTape"`);
    return true;
});
exports.filterGeneratedRepaymentTapes = filterGeneratedRepaymentTapes;
const filterAssignedRepaymentTapes = ({ dataTapes, }) => dataTapes
    .filter(dbNodes.assignedRepaymentTape.isNodeIntermediate)
    .filter((artifact) => {
    (0, common_1.finleyAssert)(dbNodes.assignedRepaymentTape.typeGuardIntermediate(artifact), `[${artifact.id}] is not intermediate "AssignedRepaymentTape"`);
    return true;
});
exports.filterAssignedRepaymentTapes = filterAssignedRepaymentTapes;
const filterSyntheticAssignedRepaymentTapes = ({ dataTapes, }) => dataTapes.filter(dbNodes.assignedRepaymentTape.isNode).filter((artifact) => {
    (0, common_1.finleyAssert)(dbNodes.assignedRepaymentTape.typeGuard(artifact), `[${artifact.id}] is not "AssignedRepaymentTape"`);
    return true;
});
exports.filterSyntheticAssignedRepaymentTapes = filterSyntheticAssignedRepaymentTapes;
const filterInternalRepaymentTapes = ({ dataTapes, }) => dataTapes.filter(dbNodes.internalRepaymentTape.isNode).filter((artifact) => {
    (0, common_1.finleyAssert)(dbNodes.internalRepaymentTape.typeGuard(artifact), `[${artifact.id}] is not "InternalRepaymentTape"`);
    return true;
});
exports.filterInternalRepaymentTapes = filterInternalRepaymentTapes;
const filterCashResponseTapes = ({ dataTapes, }) => dataTapes.filter(dbNodes.cashResponseTape.isNode).filter((artifact) => {
    (0, common_1.finleyAssert)(dbNodes.cashResponseTape.typeGuard(artifact), `[${artifact.id}] is not "cashResponseTape"`);
    return true;
});
exports.filterCashResponseTapes = filterCashResponseTapes;
const filterWaitForDataLakeTables = ({ dataTapes, }) => dataTapes.filter(dbNodes.waitForDataLakeTable.isNode);
exports.filterWaitForDataLakeTables = filterWaitForDataLakeTables;
const filterManualBankAccountReports = ({ dataTapes, }) => dataTapes.filter(dbNodes.manualBankAccountReport.isNode);
exports.filterManualBankAccountReports = filterManualBankAccountReports;
const filterReconciledBusTapes = ({ dataTapes, }) => dataTapes.filter(dbNodes.reconciledBusTape.isNode);
exports.filterReconciledBusTapes = filterReconciledBusTapes;
const filterCashBalancesFeedContexts = ({ dataTapes, }) => dataTapes.filter(dbNodes.cashBalancesFeedContext.isNode);
exports.filterCashBalancesFeedContexts = filterCashBalancesFeedContexts;
const filterFundingRequests = ({ dataTapes, }) => dataTapes.filter(dbNodes.fundingRequest.isNode);
exports.filterFundingRequests = filterFundingRequests;
const filterApprovalReports = ({ dataTapes, }) => dataTapes.filter(dbNodes.fundingApprovalReport.isNode);
exports.filterApprovalReports = filterApprovalReports;
const getDependenciesByOutputId = ({ outputArtifactId, dataTapeDependencies, }) => {
    const dependencies = dataTapeDependencies.filter((dep) => dep.outputArtifactId === outputArtifactId);
    return dependencies;
};
exports.getDependenciesByOutputId = getDependenciesByOutputId;
const getInputTapes = ({ outputArtifactId, dbGraph, }) => {
    const { dataTapeDependencies, dataTapes } = dbGraph;
    return (0, exports.getDependenciesByOutputId)({
        outputArtifactId,
        dataTapeDependencies,
    }).map(({ inputArtifactId }) => {
        return (0, exports.findArtifactById)({
            artifactId: inputArtifactId,
            dataTapes,
        });
    });
};
exports.getInputTapes = getInputTapes;
const getAllDependencyInputTapes = ({ outputArtifactId, dbGraph, }) => {
    const inputTapes = (0, exports.getInputTapes)({ outputArtifactId, dbGraph });
    return inputTapes.reduce((acc, inputTape) => {
        acc.push(inputTape);
        const inputTapesForInputTape = (0, exports.getInputTapes)({
            outputArtifactId: inputTape.id,
            dbGraph,
        });
        if (inputTapesForInputTape.length) {
            const inputTapesForInputTapeDependencies = (0, exports.getAllDependencyInputTapes)({
                outputArtifactId: inputTape.id,
                dbGraph,
            });
            inputTapesForInputTapeDependencies.forEach((dependency) => {
                // prevent duplicate dependencies being added if graphs diverged and then remerged
                if (!acc.find(({ id }) => dependency.id === id)) {
                    acc.push(dependency);
                }
            });
        }
        return acc;
    }, []);
};
exports.getAllDependencyInputTapes = getAllDependencyInputTapes;
const getDependenciesByInputId = ({ inputArtifactId, dataTapeDependencies, }) => {
    const dependencies = dataTapeDependencies.filter((dep) => dep.inputArtifactId === inputArtifactId);
    return dependencies;
};
exports.getDependenciesByInputId = getDependenciesByInputId;
const getOutputTapes = ({ inputArtifactId, dbGraph, }) => {
    const { dataTapeDependencies, dataTapes } = dbGraph;
    return (0, exports.getDependenciesByInputId)({
        inputArtifactId,
        dataTapeDependencies,
    }).map(({ outputArtifactId }) => {
        return (0, exports.findArtifactById)({
            artifactId: outputArtifactId,
            dataTapes,
        });
    });
};
exports.getOutputTapes = getOutputTapes;
const filterUserInputNeededNodesForAssignment = ({ dataTapes, dataTapeDependencies, }) => {
    return dataTapes.filter(dbNodes.userInputNeeded.isNode).filter((artifact) => {
        return (0, exports.getOutputTapes)({
            inputArtifactId: artifact.id,
            dbGraph: { dataTapes, dataTapeDependencies },
        }).some((outputTape) => outputTape.type === 'assignedLoanTape');
    });
};
exports.filterUserInputNeededNodesForAssignment = filterUserInputNeededNodesForAssignment;
const filterUserInputNeededNodesCashBalanceContext = ({ dataTapes, dataTapeDependencies, }) => {
    return dataTapes.filter(dbNodes.userInputNeeded.isNode).filter((artifact) => {
        return (0, exports.getOutputTapes)({
            inputArtifactId: artifact.id,
            dbGraph: { dataTapes, dataTapeDependencies },
        }).some((outputTape) => outputTape.type === 'cashBalancesFeedContext');
    });
};
exports.filterUserInputNeededNodesCashBalanceContext = filterUserInputNeededNodesCashBalanceContext;
const filterUserInputNeededNodesDataLakeWait = ({ dataTapes, }) => {
    return dataTapes.filter((node) => dbNodes.userInputNeeded.isNode(node) &&
        node.configuration.inputType === 'dataLakeTableHydration');
};
exports.filterUserInputNeededNodesDataLakeWait = filterUserInputNeededNodesDataLakeWait;
const filterUserInputNeededNodesBusApproval = ({ dataTapes, }) => {
    return dataTapes.filter((node) => dbNodes.userInputNeeded.isNode(node) &&
        node.configuration.inputType === 'busReconcileApproval');
};
exports.filterUserInputNeededNodesBusApproval = filterUserInputNeededNodesBusApproval;
const getDependency = ({ outputArtifactId, inputArtifactId, dataTapeDependencies, }) => {
    const dependencies = dataTapeDependencies.filter((dep) => dep.inputArtifactId === inputArtifactId &&
        dep.outputArtifactId === outputArtifactId);
    (0, common_1.finleyAssert)(dependencies.length === 1, 'unable to get dependency');
    return dependencies[0];
};
exports.getDependency = getDependency;
const insertDependency = ({ dataTapeDependency, insertId, }) => {
    const { outputArtifactId, inputArtifactId } = dataTapeDependency;
    const outputDependency = {
        outputArtifactId,
        inputArtifactId: insertId,
    };
    const inputDependency = {
        outputArtifactId: insertId,
        inputArtifactId,
    };
    return { outputDependency, inputDependency };
};
exports.insertDependency = insertDependency;
const removeDependenciesByInputArtifactId = ({ dataTapeDependencies, inputArtifactIds, }) => {
    const inputArtifactIdSet = new Set(inputArtifactIds);
    return (0, remeda_1.filter)(dataTapeDependencies, (dep) => !inputArtifactIdSet.has(dep.inputArtifactId));
};
exports.removeDependenciesByInputArtifactId = removeDependenciesByInputArtifactId;
const removeDependenciesByOutputArtifactId = ({ dataTapeDependencies, outputArtifactIds, }) => {
    const outputArtifactIdSet = new Set(outputArtifactIds);
    return (0, remeda_1.filter)(dataTapeDependencies, (dep) => !outputArtifactIdSet.has(dep.outputArtifactId));
};
exports.removeDependenciesByOutputArtifactId = removeDependenciesByOutputArtifactId;
const removeArtifactsByTypes = ({ dataTapes, types, }) => {
    const artifactTypeSet = new Set(types);
    return (0, remeda_1.filter)(dataTapes, (tape) => !artifactTypeSet.has(tape.type));
};
exports.removeArtifactsByTypes = removeArtifactsByTypes;
const removeDependency = ({ dataTapeDependencies, dependencyToRemove, }) => {
    const res = (0, remeda_1.filter)(dataTapeDependencies, (dep) => !(dep.inputArtifactId === dependencyToRemove.inputArtifactId &&
        dep.outputArtifactId === dependencyToRemove.outputArtifactId));
    (0, common_1.finleyAssert)(dataTapeDependencies.length - res.length === 1, `unable to remove dependency [outputArtifactId:${dependencyToRemove.outputArtifactId}] [inputArtifactId:${dependencyToRemove.inputArtifactId}]`);
    return res;
};
exports.removeDependency = removeDependency;
const removeDependencies = ({ dataTapeDependencies, dependenciesToRemove: _dependenciesToRemove, }) => {
    const dependenciesToRemove = cloneDeep(_dependenciesToRemove);
    if (!dependenciesToRemove.length)
        return dataTapeDependencies;
    const dependencyToRemove = dependenciesToRemove.shift();
    (0, common_1.finleyAssert)(dependencyToRemove, 'dependencyToRemove must exist');
    const deps = (0, exports.removeDependency)({
        dataTapeDependencies,
        dependencyToRemove,
    });
    return (0, exports.removeDependencies)({
        dataTapeDependencies: deps,
        dependenciesToRemove,
    });
};
exports.removeDependencies = removeDependencies;
// asserts that there are no duplicate dependencies in the dataTapeDependencies
// the failures message includes the `artifactSlug => artifactSlug` that was duplicated
const ensureNoDuplicateDependencies = ({ functionName, dbGraph, }) => {
    const { dataTapeDependencies, dataTapes } = dbGraph;
    const dependencies = dataTapeDependencies.map(({ outputArtifactId, inputArtifactId }) => {
        const outputArtifact = (0, exports.findArtifactById)({
            artifactId: outputArtifactId,
            dataTapes,
        });
        const inputArtifact = (0, exports.findArtifactById)({
            artifactId: inputArtifactId,
            dataTapes,
        });
        (0, common_1.finleyAssert)(outputArtifact, `${functionName}: Unable to find outputArtifact for ${outputArtifactId}`);
        (0, common_1.finleyAssert)(inputArtifact, `${functionName}: Unable to find inputArtifact for ${inputArtifactId}`);
        return `${inputArtifact.artifactSlug} => ${outputArtifact.artifactSlug}`;
    });
    // ensure no duplicate dependencies
    dependencies.forEach((dependency) => {
        const count = dependencies.filter((d) => d === dependency).length;
        (0, common_1.finleyAssert)(count === 1, `${functionName}: Duplicate dependency found: ${dependency} (count: ${count})`);
    });
};
exports.ensureNoDuplicateDependencies = ensureNoDuplicateDependencies;
const generateLoanTapeTypeMap = (dataTapes) => {
    const generatedLoanTapes = (0, exports.filterGeneratedLoanTapes)({ dataTapes });
    (0, common_1.finleyAssert)((0, exports.hasLoanProductSlug)(generatedLoanTapes), 'generatedLoanTapes must have loanProductSlug');
    return (0, remeda_1.reduce)(generatedLoanTapes, (acc, tape) => {
        if (acc[tape.loanProductSlug]) {
            (0, common_1.finleyAssert)(acc[tape.loanProductSlug] === tape.configuration.loanTapeType, new common_1.error.FinleyError('loanProduct loanTapeType is configured inconsistently.'));
            return acc;
        }
        (0, common_1.finleyAssert)(finley_types_1.typeguards.loanProduct.isLoanTapeType(tape.configuration.loanTapeType), new common_1.error.FinleyError('loanTapeType must be configured on generated loan tape as valid loanTapeType.'));
        return {
            ...acc,
            [tape.loanProductSlug]: tape.configuration.loanTapeType,
        };
    }, {});
};
exports.generateLoanTapeTypeMap = generateLoanTapeTypeMap;
//# sourceMappingURL=utils.js.map